/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as yup from 'yup';

import { convertEmptyStringToNull } from '../../../util/helpers';
import {
  CUSTOM_EXTENSION_DESCRIPTION_MAX_LENGTH,
  CUSTOM_EXTENSION_NAME_MAX_LENGTH,
  NO_ONLY_SPACES_REGEX
} from '../../../util/validation/constants';
import { CATALOG_ITEM_TYPE } from '../constants';
import { Register as messages } from './messages';

export const registerSchema = yup.object().shape({
  title: yup
    .string()
    .required(messages.extensionNameRequired.defaultMessage)
    .matches(NO_ONLY_SPACES_REGEX, {
      message: messages.nonEmptyTitle.defaultMessage,
      excludeEmptyString: true
    })
    .max(
      CUSTOM_EXTENSION_NAME_MAX_LENGTH,
      messages.extensionNameMaxLength.defaultMessage
    ),
  description: yup
    .string()
    .nullable()
    // Convert empty strings to null for store
    .transform(value => convertEmptyStringToNull(value))
    .default(null)
    .matches(NO_ONLY_SPACES_REGEX, {
      message: messages.nonEmptyDescription.defaultMessage,
      excludeEmptyString: true
    })
    .max(
      CUSTOM_EXTENSION_DESCRIPTION_MAX_LENGTH,
      messages.extensionDescriptionMaxLength.defaultMessage
    ),
  specification: yup.object().shape({
    type: yup.string().default(CATALOG_ITEM_TYPE),
    body: yup.object().default(undefined)
  })
});

export const FIELDS = {
  DESCRIPTION: 'description',
  TITLE: 'title',
  SPECIFICATION: 'specification',
  SPECIFICATION_BODY: 'specification.body'
};
